import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './dayScheduleTabChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'fioajifamelkme'}
})
export class DayScheduleTabChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalDayScheduleTabs: any;
    
    public dayScheduleTabs: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("day_schedule_tabs/update_order", { day_schedule_tab_ids: this.dayScheduleTabs.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.dayScheduleTabs, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.dayScheduleTabs = JSON.parse(JSON.stringify(this.originalDayScheduleTabs));
    }
}
